export default "__VITE_ASSET__aeJjYl6L__"